<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Testbed User</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #userForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr *ngIf="tmpUser?._id">
                    <th>ID</th>
                    <td>{{tmpUser?._id}}</td>
                </tr>
                <tr>
                    <th>Email</th>
                    <td>
                        <input size=70 name="email" type='email' class="form-control w-100"
                            [(ngModel)]="tmpUser.email" #email="ngModel" required email
                            [ngClass]="{ 'invalid-input': email.invalid && (email.dirty || email.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Password</th>
                    <td>
                        <div *ngIf="user?._id; else new_user_password" class="font-italic small light-gray">
                            <input size=70 id="password" name="password" class="form-control w-100"
                            [(ngModel)]="tmpUser.password" #password="ngModel"
                            [ngClass]="{ 'invalid-input': password.invalid && (password.dirty || password.touched)}" >
                            <div class="text-right">* Leave empty to keep existing password</div>
                        </div>
                        <ng-template #new_user_password>
                            <input size=70 id="password" name="password" class="form-control w-100"
                            [(ngModel)]="tmpUser.password" #password="ngModel" required
                            [ngClass]="{ 'invalid-input': password.invalid && (password.dirty || password.touched)}" >
                        </ng-template>
                    </td>
                </tr>
                <tr>
                    <th>Login Fails (consecutive)</th>
                    <td>
                        <input size=3 name="loginFailCnt" type='number' class="form-control w-100"
                        [(ngModel)]="tmpUser.loginFailCnt" #loginFailCnt="ngModel"
                        [ngClass]="{ 'invalid-input': loginFailCnt.invalid && (loginFailCnt.dirty || loginFailCnt.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>First Name</th>
                    <td>
                        <input size=70 name="firstName" type='text' class="form-control w-100"
                            [(ngModel)]="tmpUser.firstName" #firstName="ngModel" required
                            [ngClass]="{ 'invalid-input': firstName.invalid && (firstName.dirty || firstName.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Last Name</th>
                    <td>
                        <input size=70 id="lastName" name="lastName" type='text' class="form-control w-100"
                            [(ngModel)]="tmpUser.lastName" #lastName="ngModel" required
                            [ngClass]="{ 'invalid-input': lastName.invalid && (lastName.dirty || lastName.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Phone</th>
                    <td>
                        <input size=70 id="phone" name="phone" type='text' class="form-control w-100"
                            [(ngModel)]="tmpUser.phone" #phone="ngModel"
                            [ngClass]="{ 'invalid-input': phone.invalid && (phone.dirty || phone.touched)}" >
                    </td>
                </tr>                
                <tr>
                    <th>Role</th>
                    <td>
                        <select name="role" [(ngModel)]="tmpUser.role">
                            <option *ngFor="let role of userRoles" [ngValue]="role.id">{{role.name}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button [disabled]="bProcessing || !userForm.dirty || userForm.invalid" (click)="onSave()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
